import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';


export function getHomeInfoSuccess(home) {
  return {type: types.LOAD_HOME_INFO_SUCCESS, datos:home};
}



export function getHomeInfo(  ) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getHomeInfo( ).then(home => {                  
                  dispatch(getHomeInfoSuccess(home));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCursosGratuitosSuccess(cursos) {
  return {type: types.LOAD_CURSOS_GRATUITOS_SUCCESS, datos:cursos};
}



export function getCursosGratuitos(  ) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getCursosGratuitos( ).then(cursos => {                  
                  dispatch(getCursosGratuitosSuccess(cursos));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

export function getCursosCarruselSuccess(cursos) {
  return {type: types.LOAD_CURSOS_CARRUSEL_SUCCESS, datos:cursos};
}



export function getCursosCarrusel(  ) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getCursosCarrusel( ).then(cursos => {                  
                  dispatch(getCursosCarruselSuccess(cursos));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCursoDetalle(id) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getCursoDetalle(id ).then(curso => {                  
                  dispatch(sinReducerSuccess(curso));
                  return curso;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

export function getCursoDetalleUsuario(idCurso, idUsuario) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getCursoDetalleUsuario(idCurso, idUsuario ).then(curso => {                  
                  dispatch(sinReducerSuccess(curso));
                  return curso;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

export function getCursoDetalleInfo(id) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getCursoDetalleInfo(id).then(curso => {                  
                  dispatch(sinReducerSuccess(curso));
                  return curso;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function getCursoOpinion(id) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getCursoOpinion(id).then(opinion => {                  
                  dispatch(sinReducerSuccess(opinion));
                  return opinion;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getCursosConstancias() {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getCursosConstancias().then(cursos => {                  
                  dispatch(sinReducerSuccess(cursos));
                  return cursos;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function validaDatos(constancia) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.validaDatos(constancia).then(respuesta => {                  
                  dispatch(sinReducerSuccess(respuesta));
                  return respuesta;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function getInsigniaInfo() {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getInsigniaInfo( ).then(insignias => {                  
                  dispatch(sinReducerSuccess(insignias));
                  return insignias;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getInstructoresSuccess(instructores) {
  return {type: types.LOAD_INSTRUCTORES_SUCCESS, datos:instructores};
}

export function getInstructores(tipo) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getInstructores(tipo ).then(instructores => {                  
                  dispatch(getInstructoresSuccess(instructores));
                  
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getStaff() {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getStaff().then(instructores => {                  
                  dispatch(getInstructoresSuccess(instructores));
                  
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getPreguntasFrecuentesSuccess(preguntas) {
  return {type: types.LOAD_PREGUNTAS_FRECUENTES_SUCCESS, datos:preguntas};
}

export function getPreguntasFrecuentes() {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getPreguntasFrecuentes( ).then(preguntas => {                  
                  dispatch(getPreguntasFrecuentesSuccess(preguntas));
                  
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setInfoSuccess(paginaInfo) {
  return {type: types.SET_STRINGS_SUCCESS, datos:paginaInfo};
}


export function getInfo(pagina) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InfoApi.getInfo(pagina).then(paginaInfo => {    
                  dispatch(setInfoSuccess(paginaInfo));
                  return paginaInfo; 
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function saveSuccess(pagos) {
  return {type: types.SAVE_PAGOS_SUCCESS, pagos};
}


export function savaPagoConstancia(pagos) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().InfoApi.savaPagoConstancia(pagos).then(pagosGuardado => {   
    dispatch(saveSuccess(pagosGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

